import { inject, injectable } from "inversify";
import { TYPES } from "@utils/inversifyJS/types";
import type { IFastaRepository } from "@domain/repositories";

@injectable()
class DeleteFastaService {
    @inject(TYPES.IFastaRepository)
    private _fastaRepository!: IFastaRepository;

    async executeAsync(fileName: string, folder: string | undefined): Promise<boolean> {
        return this._fastaRepository.deleteFileAsync(fileName, folder);
    }
}
export { DeleteFastaService };
